<ng-container *ngIf="tabs$ | async as featureTabs">
  <nav data-at-tabs mat-tab-nav-bar [tabPanel]="tabPanel" class="gap">
    <ng-container *ngFor="let f of featureTabs; let i = index">
      <a
        data-at-tab
        mat-tab-link
        *ngIf="f | ready as feature"
        id="tab-{{ feature.feature }}"
        [class.active]="activeTab === feature.feature"
        [active]="activeTab === feature.feature"
        gtm="onSelect"
        gtmAction="Tab of heating"
        gtmCategory="switchingTimes"
        (click)="onTabChange(feature, i)"
      >
        {{ feature.feature | translateScheduleTab }}
      </a>
    </ng-container>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

  <app-timemanager
    class="gap"
    *ngIf="initTabs(featureTabs)"
    (scheduleChange)="onMultipleFamilyScheduleChange($event, featureTabs)"
  ></app-timemanager>

  <app-mfh-programs-panel
    *ngIf="editMultipleDays"
    [activeTabIndex]="activeTabIndex"
    [circuitId]="circuitId"
  ></app-mfh-programs-panel>

  <!-- programs -->
  <ng-container *ngIf="activeTabIndex === 0 && heatingSchedule$ | async | ready as heatingSchedule">
    <div class="heating-programs-title">
      <h3>
        {{
          '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.TEMPERATURE_SELECTORS.TITLE'
            | translate
        }}
      </h3>
    </div>
    <div data-at-programs class="multifamily-heating-programs">
      <ng-container *ngFor="let mode$ of modes">
        <vi-program-item
          *ngIf="mode$ | async | ready as mode"
          [program]="mode.feature | modeName: 'program'"
          [hasTemperature]="mode?.properties?.temperature?.value"
          [displayProgramTile]="false"
        >
          <vi-text name *ngIf="!(mode | executable: 'setTemperature')" class="flex-1">
            {{ mode.feature | modeName | translateOperatingProgram }}
          </vi-text>
          <app-temperature-select
            item
            *ngIf="mode | executable: 'setTemperature'"
            id="program-{{ mode.feature | modeName }}"
            [title]="mode.feature | modeName | translateOperatingProgram"
            [rangeDefinition]="mode | constraints: 'setTemperature':'targetTemperature'"
            [value]="mode.properties?.temperature?.value"
            (valueChange)="heatingPanelService.onProgramTemperatureChange($event, mode.feature)"
          ></app-temperature-select>
        </vi-program-item>
      </ng-container>
      <!-- Commented out temporarily 2.55.1 -->
      <!-- VIG-19975 -->
      <!-- Eco mode temperature -->
      <!-- <app-mfh-temperature-panel
        *ngIf="temperaturePanelEcoFeature$ | async as feature"
        [circuitId]="circuitId"
        [feature]="feature"
      ></app-mfh-temperature-panel> -->

      <!-- Comfort mode temperature -->
      <!-- <app-mfh-temperature-panel
        *ngIf="temperaturePanelComfortFeature$ | async as feature"
        [circuitId]="circuitId"
        [feature]="feature"
      ></app-mfh-temperature-panel> -->
    </div>
  </ng-container>
</ng-container>
